import _ from 'lodash';
import { createSelector } from 'reselect';

import { FeatureFlag } from 'constants/featureFlags';
import { DocumentsSubtabRouteParam } from 'constants/loanApplication';
import { PAGE_CODES } from 'constants/pageCodes';

import { getMasterPermissionsToPage } from 'store/auth/selectors';
import { selectFeatureFlagByKey } from 'store/global/selectors';

export const selectFilteredDocumentsSubtabs = createSelector(
  selectFeatureFlagByKey(FeatureFlag.HideLoanSpecificForm),
  getMasterPermissionsToPage(PAGE_CODES.FORM_DELIVERY),
  getMasterPermissionsToPage(PAGE_CODES.LOAN_EDITOR_CIC_HISTORY),
  (isHideLoanSpecificForm, formDeliveryPermissions, cicHistoryPermissions) =>
    _.filter(DocumentsSubtabRouteParam, subtab => {
      switch (subtab) {
        case DocumentsSubtabRouteParam.LOAN_SPECIFIC:
          return !isHideLoanSpecificForm;

        case DocumentsSubtabRouteParam.CIC_HISTORY:
          return !!cicHistoryPermissions?.isViewAllowed;

        case DocumentsSubtabRouteParam.DISCLOSURES:
          return !!formDeliveryPermissions?.isViewAllowed;

        default:
          return true;
      }
    }),
);
